export default function FeeFilledIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5V19.5a.75.75 0 0 0 1.086.67L6 18.838l2.664 1.332a.75.75 0 0 0 .672 0L12 18.838l2.664 1.332a.75.75 0 0 0 .672 0L18 18.838l2.664 1.332a.75.75 0 0 0 1.086-.67V5.25a1.5 1.5 0 0 0-1.5-1.5ZM16.5 13.5h-9a.75.75 0 1 1 0-1.5h9a.75.75 0 1 1 0 1.5Zm0-3h-9a.75.75 0 1 1 0-1.5h9a.75.75 0 1 1 0 1.5Z"
      />
    </svg>
  );
}
